export default "__VITE_ASSET__f9aab8fd__"